import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { App, Button } from "antd";
import { useTranslation } from "react-i18next";

import { useMarkServiceUser } from "../model/useMarkServiceUser";

/**
 * Пометить аккаунт служебным или снять пометку.
 *
 * Подтверждение спрашивается только при включении: пометка меняет то, что
 * видят посторонние на витрине робота, а снятие лишь возвращает человека в
 * общий порядок.
 */
export function MarkServiceUserButton({
  userId,
  service,
}: {
  userId: number;
  service: boolean;
}) {
  const { t } = useTranslation();
  const { modal, message } = App.useApp();
  const mutation = useMarkServiceUser(userId);

  return (
    <Button
      icon={service ? <EyeOutlined aria-hidden /> : <EyeInvisibleOutlined aria-hidden />}
      loading={mutation.isPending}
      onClick={() => {
        if (service) {
          mutation.mutate(
            { is_service: false },
            {
              onSuccess: () => {
                void message.success(t("users.serviceOffDone"));
              },
            },
          );
          return;
        }
        void modal.confirm({
          title: t("users.serviceOn"),
          content: t("users.serviceHint"),
          okText: t("users.serviceOn"),
          cancelText: t("common.cancel"),
          onOk: async () => {
            await mutation.mutateAsync({ is_service: true });
            void message.success(t("users.serviceOnDone"));
          },
        });
      }}
    >
      {service ? t("users.serviceOff") : t("users.serviceOn")}
    </Button>
  );
}
